// EWM-196 / EWM-641 — canonical Electus Distribution Zendesk "Request a Quote"
// form URL per country. Shared by the PDP "Request a Quote" link and the cart's
// over-stock line error (restricted customers who can't back-order are told to
// submit a quote for the shortfall). Keyed by the country code (au / nz) from
// useShipAndLanguage().selectedLocation; defaults to AU when unknown.
const ZENDESK_QUOTE_FORM_URL: Record<string, string> = {
  au: 'https://help.electusdistribution.com.au/hc/en-us/requests/new?ticket_form_id=57909603591705',
  nz: 'https://help.electusdistribution.co.nz/hc/en-us/requests/new?ticket_form_id=57909603591705',
};

export const resolveQuoteFormUrl = (country?: string): string =>
  ZENDESK_QUOTE_FORM_URL[(country ?? 'au').toLowerCase()] ?? ZENDESK_QUOTE_FORM_URL.au;
